//Content Card onclick
export const CONTENT_CARD_CLICK = "CONTENT_CARD_CLICK"
export const CONTENT_CARD_CLICK_SUCCESS = "CONTENT_CARD_CLICK_SUCCESS"
export const CONTENT_CARD_CLICK_API_ERROR = "CONTENT_CARD_CLICK_API_ERROR"